import type { BaseNavigationLink, BaseNavigationLinkGroup } from '@su4r-frontend/api';

export function isBaseNavigationLinkGroup(
    link: BaseNavigationLink | BaseNavigationLinkGroup
): link is BaseNavigationLinkGroup {
    return (link as BaseNavigationLinkGroup).alias === 'linkGroup';
}
